<template>
  <div
    class="bg-yellow-100 text-yellow-900 p-4 lg:flex items-center justify-left gap-2 rounded-lg my-8 text-center lg:text-left"
    :class="containerClass"
  >
    <vue-feather type="alert-triangle" class="h-8 mx-auto lg:mx-0" />
    <div class="lg:ml-8">
      <header class="font-bold">{{ title }}</header>
      <p class="mt-1">{{ message }}</p>
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    containerClass: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Your job posting needs a refresh',
    },
    message: {
      type: String,
      default:
        "This job hasn't been updated in over 30 days. Updating your job details now will help improve your recruiting results, by increasing your visibility to candidates.",
    },
  },
};
</script>
